const ICON = {
  CLOSE: 'CLOSE',
  BACK: 'BACK',
  MINUS: 'MINUS',
  PLUS: 'PLUS',
  CHEVRON_RIGHT: 'CHEVRON_RIGHT',
  CHEVRON_LEFT: 'CHEVRON_LEFT',
  EYE_OPEN: 'EYE_OPEN',
  EYE_CLOSED: 'EYE_CLOSED',
  MENU: 'MENU',
  LOGO: 'LOGO',
  CART: 'CART',
  RETURN: 'RETURN',
  OXIDATIVE_STRESS: 'OXIDATIVE_STRESS',
  SKIN_APPEARANCE: 'SKIN_APPEARANCE',
  SKIN_REDNESS: 'SKIN_REDNESS',
  SKIN_DRYNESS: 'SKIN_DRYNESS',
  SKIN_OILINESS: 'SKIN_OILINESS',
  SKIN_TEXTURE: 'SKIN_TEXTURE',
  PIMPLES: 'PIMPLES',
  SKIN_PIGMENTATION: 'SKIN_PIGMENTATION',
  UNIVERSKIN_SHIELD: 'UNIVERSKIN_SHIELD',
  NO_SILICONS: 'NO_SILICONS',
  NO_MIT_MCIT: 'NO_MIT_MCIT',
  NO_PHENOXYETHANOL: 'NO_PHENOXYETHANOL',
  NO_ENDOCRINE_DISRUPTORS: 'NO_ENDOCRINE_DISRUPTORS',
  NO_MINERAL_OILS: 'NO_MINERAL_OILS',
  NO_PEG: 'NO_PEG',
  NO_SULFATES: 'NO_SULFATES',
  NO_GMO: 'NO_GMO',
  NO_NANO: 'NO_NANO',
  NO_ALCOHOL_DENAT: 'NO_ALCOHOL_DENAT',
  FRAGRANCE: 'FRAGRANCE',
  VEGAN: 'VEGAN',
  GLUTEN_FREE: 'GLUTEN_FREE',
  CRUELTY_FREE: 'CRUELTY_FREE',
  CLINICALLY_PROVEN: 'CLINICALLY_PROVEN',
  MOON: 'MOON',
  SUN: 'SUN',
  MOON_AND_SUN: 'MOON_AND_SUN',
  EYE_IN_CIRCLE: 'EYE_IN_CIRCLE',
  FACE: 'FACE',
  BOX: 'BOX',
  STETHOSCOPE: 'STETHOSCOPE',
  CHECK: 'CHECK',
  ANGLE: 'ANGLE',
  SPIDER_CHART: 'SPIDER_CHART',
  RUBIC: 'RUBIC',
  BOTTLES: 'BOTTLES',
  CLOCK: 'CLOCK',
  WEB: 'WEB',
  INFO: 'INFO',
  ANGLE_THIN: 'ANGLE_THIN',
  ENVELOPE: 'ENVELOPE',
  LINK: 'LINK',
  LOGO_WITH_TITLE: 'LOGO_WITH_TITLE',
  SCROLL_DOWN: 'SCROLL_DOWN',
  WARNING: 'WARNING'
};

const ICON_VALUE = {
  [ICON.CLOSE]: '\u0078',
  [ICON.BACK]: '\u23CE',
  [ICON.MINUS]: '\u002D',
  [ICON.PLUS]: '\u002B',
  [ICON.CHEVRON_RIGHT]: '\u003E',
  [ICON.CHEVRON_LEFT]: '\u003C',
  [ICON.EYE_OPEN]: '\u25EF',
  [ICON.EYE_CLOSED]: '\u2298',
  [ICON.MENU]: '\u2261',
  [ICON.LOGO]: '\u24CA',
  [ICON.CART]: '\u25A2',
  [ICON.RETURN]: '\u23CE',
  [ICON.OXIDATIVE_STRESS]: '\u004F',
  [ICON.SKIN_APPEARANCE]: '\u0041',
  [ICON.SKIN_REDNESS]: '\u0052',
  [ICON.SKIN_DRYNESS]: '\u0044',
  [ICON.SKIN_OILINESS]: '\u0049',
  [ICON.SKIN_TEXTURE]: '\u0054',
  [ICON.PIMPLES]: '\u004D',
  [ICON.SKIN_PIGMENTATION]: '\u0050',
  [ICON.UNIVERSKIN_SHIELD]: '\u0055',
  [ICON.NO_SILICONS]: '\u0061',
  [ICON.NO_MIT_MCIT]: '\u0062',
  [ICON.NO_PHENOXYETHANOL]: '\u0063',
  [ICON.NO_ENDOCRINE_DISRUPTORS]: '\u0064',
  [ICON.NO_MINERAL_OILS]: '\u0065',
  [ICON.NO_PEG]: '\u0066',
  [ICON.NO_SULFATES]: '\u0067',
  [ICON.NO_GMO]: '\u0068',
  [ICON.NO_NANO]: '\u0069',
  [ICON.NO_ALCOHOL_DENAT]: '\u006A',
  [ICON.FRAGRANCE]: '\u006B',
  [ICON.VEGAN]: '\u006C',
  [ICON.GLUTEN_FREE]: '\u006D',
  [ICON.CRUELTY_FREE]: '\u006E',
  [ICON.CLINICALLY_PROVEN]: '\u006F',
  [ICON.MOON]: '\u0070',
  [ICON.SUN]: '\u0071',
  [ICON.MOON_AND_SUN]: '\u0072',
  [ICON.EYE_IN_CIRCLE]: '\u0073',
  [ICON.FACE]: '\u0074',
  [ICON.BOX]: '\u0075',
  [ICON.STETHOSCOPE]: '\u0076',
  [ICON.CHECK]: '\u2713',
  [ICON.ANGLE]: '\u0079',
  [ICON.SPIDER_CHART]: '\u00A4',
  [ICON.RUBIC]: '\u00A5',
  [ICON.BOTTLES]: '\u00A6',
  [ICON.CLOCK]: '\u00A7',
  [ICON.WEB]: '\u0077',
  [ICON.INFO]: '\u0021',
  [ICON.ANGLE_THIN]: '\u007A',
  [ICON.ENVELOPE]: '\u00A8',
  [ICON.LINK]: '\u00A9',
  [ICON.LOGO_WITH_TITLE]: '\u00AA',
  [ICON.SCROLL_DOWN]: '\u290b',
  [ICON.WARNING]: '\u0045'
};

const UNICODE_ICONS = {
  ARROW_RIGHT: '\u2192'
};

export { ICON, ICON_VALUE, UNICODE_ICONS };
